import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { TaskEffects } from './task.effects';
import { TaskReducer } from './task.reducer';
import { TaskService } from './task.service';

export const provideTaskFeature = () => [
  provideState('task', TaskReducer),
  provideEffects(TaskEffects),
  TaskService
];
